// src/index.ts
import { ObjectId } from "bson";
import { z } from "zod";
import { zodToJsonSchema } from "zod-to-json-schema";
function convertJSONSchema7Definition(root, input) {
  if (typeof input === "boolean") {
    return input;
  }
  return jsonSchemaToMongoSchema(root, input);
}
function convertJSONSchema7DefinitionNoBoolean(root, input) {
  if (typeof input === "boolean") {
    throw new Error("Boolean not supported");
  }
  return jsonSchemaToMongoSchema(root, input);
}
function convertTypeToBsonType(type) {
  switch (type) {
    case "string":
      return "string";
    case "number":
      return "number";
    case "integer":
      return "int";
    case "boolean":
      return "bool";
    case "object":
      return "object";
    case "array":
      return "array";
    case "null":
      return "null";
  }
}
var zObjectId = z.custom((v) => {
  return ObjectId.isValid(v);
}).transform((v) => new ObjectId(v)).describe("Identifiant unique");
function resolveRef(root, ref) {
  const result = {};
  if (ref === "#/definitions/objectId") {
    result.bsonType = "objectId";
    return result;
  }
  const parts = ref.split("/").slice(1);
  const schema = parts.reduce((acc, part) => {
    if (!(part in acc)) {
      throw new Error(`Cannot resolve reference ${ref}`);
    }
    return acc[part];
  }, root);
  return jsonSchemaToMongoSchema(root, schema);
}
var jsonSchemaToMongoSchema = (root, schema) => {
  let result = {};
  if (schema.additionalItems != null) {
    result.additionalItems = convertJSONSchema7Definition(
      root,
      schema.additionalItems
    );
  }
  if (schema.additionalProperties != null) {
    if (typeof schema.additionalProperties === "boolean") {
      result.additionalProperties = schema.additionalProperties;
    } else if (Object.keys(schema.additionalProperties).length === 0) {
      result.additionalProperties = true;
    } else {
      result.additionalProperties = convertJSONSchema7Definition(
        root,
        schema.additionalProperties
      );
    }
  }
  if (schema.allOf) {
    result.allOf = schema.allOf.map(
      (s) => convertJSONSchema7DefinitionNoBoolean(root, s)
    );
  }
  if (schema.anyOf) {
    result.anyOf = schema.anyOf.map(
      (s) => convertJSONSchema7DefinitionNoBoolean(root, s)
    );
  }
  if (schema.dependencies) {
    result.dependencies = Object.entries(schema.dependencies).reduce(
      (acc, [k, v]) => {
        acc[k] = Array.isArray(v) ? v : convertJSONSchema7DefinitionNoBoolean(root, v);
        return acc;
      },
      {}
    );
  }
  if (schema.description != null)
    result.description = schema.description;
  if (schema.enum != null)
    result.enum = schema.enum;
  if (schema.exclusiveMaximum != null) {
    result.exclusiveMaximum = true;
    result.maximum = schema.exclusiveMaximum;
  }
  if (schema.exclusiveMinimum != null) {
    result.exclusiveMinimum = true;
    result.minimum = schema.exclusiveMinimum;
  }
  if (schema.items != null) {
    result.items = Array.isArray(schema.items) ? schema.items.map((s) => convertJSONSchema7DefinitionNoBoolean(root, s)) : convertJSONSchema7DefinitionNoBoolean(root, schema.items);
  }
  if (schema.maximum != null)
    result.maximum = schema.maximum;
  if (schema.maxItems != null)
    result.maxItems = schema.maxItems;
  if (schema.maxLength != null)
    result.maxLength = schema.maxLength;
  if (schema.maxProperties != null)
    result.maxProperties = schema.maxProperties;
  if (schema.minimum != null)
    result.minimum = schema.minimum;
  if (schema.minItems != null)
    result.minItems = schema.minItems;
  if (schema.minLength != null)
    result.minLength = schema.minLength;
  if (schema.minProperties != null)
    result.minProperties = schema.minProperties;
  if (schema.multipleOf != null)
    result.multipleOf = schema.multipleOf;
  if (schema.not != null)
    result.not = convertJSONSchema7DefinitionNoBoolean(root, schema.not);
  if (schema.oneOf != null)
    result.oneOf = schema.oneOf.map(
      (s) => convertJSONSchema7DefinitionNoBoolean(root, s)
    );
  if (schema.pattern != null)
    result.pattern = schema.pattern;
  if (schema.patternProperties != null) {
    result.patternProperties = Object.entries(schema.patternProperties).reduce(
      (acc, [k, v]) => {
        acc[k] = convertJSONSchema7DefinitionNoBoolean(root, v);
        return acc;
      },
      {}
    );
  }
  if (schema.properties != null) {
    result.properties = Object.entries(schema.properties).reduce(
      (acc, [k, v]) => {
        acc[k] = convertJSONSchema7DefinitionNoBoolean(root, v);
        return acc;
      },
      {}
    );
  }
  if (schema.required != null)
    result.required = schema.required;
  if (schema.title != null)
    result.title = schema.title;
  if (schema.type != null) {
    result.bsonType = Array.isArray(schema.type) ? schema.type.map(convertTypeToBsonType) : convertTypeToBsonType(schema.type);
  }
  if (schema.uniqueItems != null)
    result.uniqueItems = schema.uniqueItems;
  if (schema.format === "date-time") {
    delete result.type;
    result.bsonType = "date";
  }
  if (schema.$ref) {
    result = { ...result, ...resolveRef(root, schema.$ref) };
  }
  return result;
};
function zodToMongoSchema(input) {
  const jsonSchema = zodToJsonSchema(input, {
    definitions: {
      objectId: zObjectId
    }
  });
  return jsonSchemaToMongoSchema(jsonSchema, jsonSchema);
}
export {
  jsonSchemaToMongoSchema,
  zObjectId,
  zodToMongoSchema
};
//# sourceMappingURL=index.js.map